import React from 'react';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faStethoscope, faVials, faBookMedical} from '@fortawesome/free-solid-svg-icons';
import DashboardShell from './DashboardShell';
import {useDashboardData} from './useDashboardData';
import {StatTile, TrendLineChart} from '../../../components/charts';

type QualityData = {
    total_consultations: number;
    total_diagnostics: number;
    total_history_reports: number;
    consultations_by_day: {date: string; count: number}[];
};

/** Clinical Quality & Outcomes (P2) - execution_strategy_activity_tracker.md
 * Phase 4.5, the cheapest win: uzima_reports already had all the model/view
 * logic (wired up in Phase 1.2), it just needed a URL and now a chart. */
const ClinicalQualityDashboard: React.FC = () => {
    const {data, loading, error} = useDashboardData<QualityData>('/admin-dashboard/dashboards/clinical-quality/');

    return (
        <DashboardShell
            title="Clinical Quality & Outcomes"
            subtitle="Consultation, diagnostic, and treatment reporting activity"
            loading={loading}
            error={error}
        >
            {data && (
                <>
                    <div className="row g-3 mb-4">
                        <div className="col-md-4">
                            <StatTile icon={faStethoscope} label="Consultation Reports" value={data.total_consultations} color="#0ab39c"/>
                        </div>
                        <div className="col-md-4">
                            <StatTile icon={faVials} label="Diagnostic Reports" value={data.total_diagnostics} color="#405189"/>
                        </div>
                        <div className="col-md-4">
                            <StatTile icon={faBookMedical} label="Medical History Reports" value={data.total_history_reports} color="#8b5cf6"/>
                        </div>
                    </div>

                    <div className="uz-panel">
                        <div className="uz-panel-header"><span className="uz-section-title">Consultations (30 days)</span></div>
                        <div className="uz-panel-body">
                            <TrendLineChart data={data.consultations_by_day} xKey="date" yKey="count"/>
                        </div>
                    </div>
                </>
            )}
        </DashboardShell>
    );
};

export default ClinicalQualityDashboard;
